var alertTriggerToggle = {
	add: "Añadir trigger",
	edit: "Editar trigger",
	label: {
		addAlert: "Añadir alerta",
		upperLimit: "Límite supeior",
		lowerLimit: "Límite inferior",
		upperLimitCrossed: "Límite supeior cruzado",
		lowerLimitCrossed: "Límite inferior cruzado"
	}
};
var es = {
	alertTriggerToggle: alertTriggerToggle
};

export { alertTriggerToggle, es as default };
